import React from "react";

const Traveller = ({ contact }: { contact?: server.dto.ContactSmallV2 }) => (
  <span style={{ whiteSpace: "nowrap" }}>{contact.name.fullName}</span>
);

const Travellers = ({ travellers }: { travellers: server.dto.ContactSmallV2[] }) => (<div>{
  travellers.map((contact, index) => (travellers.length > (index + 1))
    ? [<Traveller key={index} contact={contact} />, ", "]
    : [<Traveller key={index} contact={contact} />])

}</div>);

export default Travellers;
